export const RQ_GET_EFFORT_REPORTS_API = {
  url: 'reports/web/effort/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_MIQNAF_EFFORT_REPORTS_API = {
  url: 'reports/web/miqnaf-effort/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_MYOWN_EFFORT_REPORTS_API = {
  url: 'reports/web/myown-effort/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_NEW_EFFORT_REPORTS_API = {
  url: 'reports/web/new-effort/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_EMPLOYEE_DATE_WISE_API = {
  url: 'dailyvisitattendee/reporting-for-employee-for-date/<%= locationId %>/<%= yyyyMmDd %>',
  method: 'GET',
  auth: true,
};

export const RQ_DELETE_EMPLOYEE_REPORT_API = {
  url: 'dailyvisitattendee/delete-reporting-by-attendee/<%= id %>',
  method: 'PUT',
  auth: true,
};
